const FloatingActions = (props) => {
  const { children, childrenStyle } = props;
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '60px', // Distance from the bottom of the viewport
        left: '50%', // Start from the horizontal center
        transform: 'translateX(-50%)', // Shift left by 50% of its width to truly center
        width: '100%', // Add margin from the edges
        maxWidth: '430px', // Match your app wrapper's maxWidth

        background: '#F6F4F0', // Background color
        padding: '10px', // Add some padding inside the container
        //boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)", // Floating effect
        borderRadius: '10px', // Rounded corners
        zIndex: 1000, // Ensure it floats above content
        minHeight: '57px',
        ...childrenStyle,
      }}
    >
      {children}
    </div>
  );
};
export default FloatingActions;
